
// 获取表格屏蔽列设置
export const table_check = state => state.table_check;



// WEBPACK FOOTER //
// ./src/store/getters.js